export default __webpack_public_path__ + "static/media/Wat_2.256.c219fa24.png";